import { DataProvider, GetListResult, RaRecord } from 'react-admin'
import { throwNotSupported } from '../../../dataProvider'
import getEarnings from '../repository/getEarnings'

interface EarningsResponse {
  sales: object[]
  total: { sales: number }
}

const earningsProvider: DataProvider = {
  getList: async <RecordType extends RaRecord>(
    _resource: string,
    params: object
  ): Promise<GetListResult<RecordType>> => {
    return await getEarnings(params)
      .then((response: unknown) => {
        const { sales, total } = response as EarningsResponse
        return {
          data: sales as RecordType[],
          meta: total,
          total: total.sales
        }
      })
      .catch(() => ({ data: [] as RecordType[], total: 0, meta: { sales: 0 } }))
  },
  getOne: throwNotSupported,
  getMany: throwNotSupported,
  getManyReference: throwNotSupported,
  update: throwNotSupported,
  updateMany: throwNotSupported,
  create: throwNotSupported,
  delete: throwNotSupported,
  deleteMany: throwNotSupported
}

export default earningsProvider
